import { BackOfficeAPI } from 'api/build/backofficeAPI';

export * from 'api/build/backofficeAPI';
// eslint-disable-next-line
export default new BackOfficeAPI();
